import { scroller, Element } from 'react-scroll';

const SCROLL_FORM_DURATION = 0;
const SCROLL_FORM_DELAY = 0;
const SCROLL_FORM_OFFSET = -50;

const scrollToForm = () => {
  scroller.scrollTo('form_top', {
    duration: SCROLL_FORM_DURATION,
    delay: SCROLL_FORM_DELAY,
    smooth: true,
    offset: 0
  });
};

const scrollToRequiredElem = (requiredElemName) => {
  scroller.scrollTo(requiredElemName, {
    duration: SCROLL_FORM_DURATION,
    delay: SCROLL_FORM_DELAY,
    smooth: true,
    offset: SCROLL_FORM_OFFSET
  });
};

export { scrollToForm, scrollToRequiredElem, Element };
